import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentForm } from './components/AgentForm';
import { CreateAgentData } from './types';
import { useAgents } from './hooks';
import { useToast } from '../../contexts/useToast';

const CreateAgent: React.FC = () => {
  const navigate = useNavigate();
  const { createAgent } = useAgents();
  const { showToast } = useToast();

  const handleSave = async (data: CreateAgentData) => {
    try {
      const result = await createAgent(data);

      // If agent was created successfully, navigate to edit page
      if (result.success && result.agent) {
        showToast({
          type: 'success',
          title: 'Agent Created Successfully',
          message: `Agent "${result.agent.name}" has been created and is ready for configuration.`,
          duration: 5000,
        });
        navigate(`/agents/edit/${result.agent.id}`);
        return result;
      }

      // Return the result (including errors) for the form to handle
      return result;
    } catch (err) {
      return {
        success: false,
        errors: { general: ['An unexpected error occurred'] },
      };
    }
  };

  return <AgentForm mode="create" onSave={handleSave} />;
};

export { CreateAgent };
